import store from "@/store";

export const STORE_MODULE = "onboarding";

// Shared helpers for the internal onboarding screens: toasts, confirms, badges and
// the document download, so every tab behaves the same way.
export default {
  methods: {
    dispatchOnboarding(action, payload) {
      return store.dispatch(`${STORE_MODULE}/${action}`, payload);
    },

    toastSuccess(message, title = "Success") {
      this.$bvToast.toast(message, { title, variant: "success", solid: true });
    },

    toastError(err, fallback) {
      console.error(err);
      const message =
        (err && err.response && err.response.data && err.response.data.message) || fallback;
      this.$bvToast.toast(message, { title: "Error", variant: "danger", solid: true });
    },

    confirmBox(message, { title, okVariant = "primary", okTitle = "OK" } = {}) {
      return this.$bvModal.msgBoxConfirm(message, {
        title,
        okVariant,
        okTitle,
        cancelTitle: "Cancel",
        centered: true,
      });
    },

    downloadDocument(documentId, fileName) {
      return this.dispatchOnboarding("downloadDocument", { documentId })
        .then((res) => {
          const url = URL.createObjectURL(res.data);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName || "document";
          link.click();
          URL.revokeObjectURL(url);
        })
        .catch((err) => this.toastError(err, "Download failed."));
    },

    formatSize(bytes) {
      if (!bytes) return "—";
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    },

    formatDateTime(value) {
      if (!value) return "—";
      return String(value).replace("T", " ").substring(0, 19);
    },

    requirementStatusVariant(status) {
      switch (status) {
        case "Requested":
          return "warning";
        case "Submitted":
          return "info";
        case "UnderReview":
          return "secondary";
        case "Approved":
          return "success";
        case "Rejected":
          return "danger";
        default:
          return "secondary";
      }
    },

    requirementStatusLabel(status) {
      return status === "UnderReview" ? "Under review" : status || "—";
    },

    reviewStatusVariant(status) {
      switch (status) {
        case "Pending":
          return "warning";
        case "UnderReview":
          return "secondary";
        case "Approved":
          return "success";
        case "Rejected":
          return "danger";
        case "NotApplicable":
          return "light-secondary";
        default:
          return "secondary";
      }
    },

    reviewStatusLabel(status) {
      if (status === "UnderReview") return "Under review";
      if (status === "NotApplicable") return "N/A";
      return status || "—";
    },

    sourceVariant(source) {
      switch (source) {
        case "Client":
          return "light-primary";
        case "Internal":
          return "light-info";
        case "Default":
          return "light-primary";
        case "Manual":
          return "light-info";
        case "Legacy":
          return "light-secondary";
        default:
          return "light-secondary";
      }
    },
  },
};
